





import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BpcFooter from '@shared/layouts/components/footer/footer.vue';
import BpcHeader from '@shared/layouts/components/header/header.vue';

@Component({
  name: 'bpc-pos-layout',
  components: {
    BpcHeader,
    BpcFooter,
  },
})
export default class PosLayout extends Vue {
  public isConfigOpen: boolean = false;

  /* Lifecycle hooks */
  // created () { }
  mounted() {
    //
  }
}
